<template>
	<div
		v-if="startGame"
		class="game">
		<player-details
			:active-player="activePlayer"
			:player-scores="playerScores" />

		<game-board
			:active-player="activePlayer"
			:reveal-answers="revealAnswers"
			:selected-answers="selectedAnswers"
			:winner="winner" />

		<div class="game__select">
			<h6>Make your move!</h6>
			<select-rock-paper-scissors
				:highlight-answer="!revealAnswers"
				:selected-answer="selectedAnswers.you"
				@selected="continueGame" />
		</div>
	</div>
</template>

<script>
	import DialogEndGame from '@/components/dialog/dialog-end-game.vue';
	import DialogStartGame from '@/components/dialog/dialog-start-game.vue';
	import DialogTimer from '@/components/dialog/dialog-timer.vue';
	import GameBoard from '@/components/game-board.vue';
	import PlayerDetails from '@/components/player-details.vue';
	import SelectRockPaperScissors from '@/components/select-rock-paper-scissors.vue';

	import RPSOptions, { ACTIVE_PLAYER, ANSWERS_MAP, SCORE_IDX_MAP, TIE } from '@/reference';

	export default {
		name: 'game',
		components: {
			DialogStartGame,
			GameBoard,
			PlayerDetails,
			SelectRockPaperScissors,
		},
		data() {
			return {
				activePlayer: ACTIVE_PLAYER.you.id,
				playerScores: '00', //you-computer
				revealAnswers: false,
				selectedAnswers: {
					computer: null,
					you: null,
				},
				startGame: false,
				winner: null,
			};
		},
		computed: {
			hasWinner() {
				return this.playerScores.split('').some((s) => s == 5);
			},
		},
		methods: {
			continueGame(answer) {
				if (this.hasWinner) return;

				this.winner = null;
				this.selectedAnswers.you = answer;
				this.activePlayer = ACTIVE_PLAYER.computer.id;
				this.revealAnswers = false;

				this.getComputerAnswer();
				this.triggerTimer();
			},
			displayEndGame() {
				this.$modal.open({
					component: DialogEndGame,
					clickToClose: false,
					otherBindings: {
						overlayClass: 'dialog-banner-overlay',
						contentClass: 'dialog-banner-content',
					},
					props: {
						winner: this.winner,
					},
					onClose: () => {
						this.winner = null;
						this.playerScores = '00';
						this.startGame = false;
						this.activePlayer = ACTIVE_PLAYER.you.id;

						this.startGameModal();
					},
				});
			},
			getComputerAnswer() {
				const randomNumber = Math.trunc(Math.random() * RPSOptions.length);
				this.selectedAnswers.computer = RPSOptions[randomNumber];
			},
			startGameModal() {
				this.$modal.open({
					component: DialogStartGame,
					clickToClose: false,
					otherBindings: {
						overlayClass: 'game-modal-overlay',
						contentClass: 'game-modal-content',
					},
					onClose: (answer) => {
						this.startGame = true;

						this.continueGame(answer);
					},
				});
			},
			triggerTimer() {
				this.$modal.open({
					component: DialogTimer,
					clickToClose: false,
					otherBindings: {
						overlayClass: 'dialog-banner-overlay',
						contentClass: 'dialog-banner-content',
					},
					onClose: () => {
						this.revealAnswers = true;
						this.activePlayer = ACTIVE_PLAYER.you.id;

						this.updateScore();
					},
				});
			},
			updateScore() {
				const { computer, you } = this.selectedAnswers;
				const result = ANSWERS_MAP[you.id][computer.id];

				this.winner = result;

				if (result !== TIE) {
					const idx = SCORE_IDX_MAP[result];
					const split = this.playerScores.split('');

					split[idx]++;

					this.playerScores = split.join('');
				}
			},
		},
		watch: {
			activePlayer: {
				handler(newVal) {
					if (newVal === ACTIVE_PLAYER.you.id) {
						document.body.classList.remove('gradient-right-bottom');
						document.body.classList.add('gradient-left-bottom');
					} else {
						document.body.classList.remove('gradient-left-bottom');
						document.body.classList.add('gradient-right-bottom');
					}
				},
				immediate: true,
			},
			playerScores() {
				if (this.hasWinner) {
					setTimeout(() => this.displayEndGame(), 2000);
				}
			},
		},
		mounted() {
			this.startGameModal();
		},
	};
</script>

<style lang="scss">
	.game {
		@extend %flex-column;
		gap: 20px;
		padding: 28px 24px;
		height: 100dvh;

		@include responsive(medium) {
			padding: 14px 12px;
		}

		.game-board {
			flex: 1 1 auto;
		}

		&__select {
			@extend %layout-flex-center-y;
			gap: 12px;
			margin-top: 20px;

			@include responsive($mobile-size) {
				margin-bottom: 40px;
			}
		}
	}
</style>
